import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  TextField, Button, Box, Typography, List, ListItem, ListItemText, Badge, Avatar, ListItemButton
} from '@mui/material';
import ProfileCard from '../components/ProfileCard';
import PostBoxCard from '../components/PostBoxCard';
import FeedCard from '../components/FeedCard';
import dmIcon from "../components/Icons/dmIcon.png";
import notificationIcon from "../components/Icons/notificationIcon.png";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import Divider from "@mui/material/Divider";
// display five buttons on top after login

// define a functional react component called home page
function HomePage() {
    const history = useHistory();

    // state for search input
    const [searchQuery, setSearchQuery] = useState("");

    // state for search results
    const [results, setResults] = useState([]);

    const [typingTimeout, setTypingTimeout] = useState(null);

    const [isSecondCardOnTop, setIsSecondCardOnTop] = useState(false);
    const [isThirdCardOnTop, setIsThirdCardOnTop] = useState(false);
    //const [topCard, setTopCard] = useState('first'); // can be 'first', 'second', or 'third'

    const [mostUpvotedUsersLastWeek, setMostUpvotedUsersLastWeek] = useState([]);

    //const [currentUserId, setCurrentUserId] = useState(null);
    const [topUserPost, setTopUserPost] = useState(null);
    const [topUserId, setTopUserId] = useState(null);

    const [topUserFeed, setTopUserFeed] = useState([]);

    const [currentUserId, setCurrentUserId] = useState(null);
    const [topUsers, setTopUsers] = useState([]);  // list of top 3 users
    const [featuredPosts, setFeaturedPosts] = useState({}); // userId => post
    const [feedPosts, setFeedPosts] = useState({});         // userId => posts[]
    //const [topCard, setTopCard] = useState(null);
    const [topCard, setTopCard] = useState(`first-0`);

    const [unreadCount, setUnreadCount] = useState(0);

    const [newFollowersCount, setNewFollowersCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [newUpvoteCount, setNewUpvoteCount] = useState(0);
    const [commentNotifications, setCommentNotifications] = useState([]);
    const [newCommentsCount, setNewCommentsCount] = useState(0);

    const [button3Active, setButton3Active] = useState(false);
    /*
    useEffect(() => {
    const fetchCounts = async () => {
        try {
        const res = await axios.get("/user/new-followers-count");
        setNewFollowersCount(res.data.newFollowersCount);
        // Combine into total notification count
        setNotificationsCount(prev => prev + res.data.newFollowersCount);
        } catch (err) {
        console.error("Error fetching new followers:", err);
        }
    };
    fetchCounts();
    }, []);
    */
   useEffect(() => {
        const fetchCounts = async () => {
            try {
            // Fetch new followers count
            const followersRes = await axios.get("/user/new-followers-count");
            setNewFollowersCount(followersRes.data.newFollowersCount);

            // Fetch new upvotes count
            const upvotesRes = await axios.get("/user/new-upvotes-count");
            setNewUpvoteCount(upvotesRes.data.newUpvoteCount);

            // Fetch new comments count
            const commentsRes = await axios.get("/user/new-comments-count");
            setNewCommentsCount(commentsRes.data.newCommentsCount);

            // Combine into total notifications count 
            setNotificationsCount(
                followersRes.data.newFollowersCount + upvotesRes.data.newUpvoteCount + commentsRes.data.newCommentsCount
            );
            } catch (err) {
            console.error("Error fetching notification counts:", err);
            }
        };

        fetchCounts();
    }, []);

    // Fetch unread messages periodically
    useEffect(() => {
        const fetchUnread = async () => {
            try {
                const res = await axios.get("/messages/unread-count");
                setUnreadCount(res.data.count);
            } catch (err) {
                console.error("Error fetching unread count:", err);
            }
        };

        fetchUnread(); // initial fetch
        const interval = setInterval(fetchUnread, 5000); // refresh every 5s
        return () => clearInterval(interval);
    }, []);

    /*
    useEffect(() => {
    axios.get('/api/topUpvotedUserFeed')
        .then(res => setTopUserFeed(res.data))
        .catch(err => console.error(err));
    }, []);
    */
    /*
    // get current user id
    useEffect(() => {
        axios.get('/api/me').then(res => setCurrentUserId(res.data.userId));
    }, []);
    */
   // get logged in user id
    useEffect(() => {
    axios.get('/api/me')
        .then(res => setCurrentUserId(res.data.userId))
        .catch(err => console.error("Failed to fetch current user", err));
    }, []);

    // get top users and for each user fetch featured post + feed
    /*useEffect(() => {
        axios.get('/mostUpvotedUsers')
        .then(async res => {
            setTopUsers(res.data);
            const featured = {};
            const feeds = {};


            await Promise.all(res.data.map(async user => {
            // fetch featured post
            try {
                const fpRes = await axios.get(`/api/users/${user._id}/featuredPost`);
                featured[user._id] = fpRes.data.featuredPost || null;
            } catch (err) {
                console.error("Failed to fetch featured post", err);
            }
            // fetch feed posts
            try {
                const feedRes = await axios.get(`/api/users/${user._id}/feed`);
                feeds[user._id] = feedRes.data;
            } catch (err) {
                console.error("Failed to fetch feed posts", err);
            }
            }));


            setFeaturedPosts(featured);
            setFeedPosts(feeds);
        })
        .catch(err => console.error("Failed to fetch top users", err));
    }, []);*/
    useEffect(() => {
        const fetchTopUsers = async () => {
            try {
                const res = await axios.get('/mostUpvotedUsers');
                setTopUsers(res.data);
            } catch (err) {
                console.error("Failed to fetch top users", err);
            }
        };

        fetchTopUsers();
    }, []);

    /*
    // get top user and post
    useEffect(() => {
        axios.get('/api/topUpvotedUserPost').then(res => {
            setTopUserId(res.data.topUserId);
            setTopUserPost(res.data.post);
        })
            .catch(err => console.error(err));
    }, []);
    */

    /*useEffect(() => {
        axios.get('/mostUpvotedUsers')
            .then(res => setMostUpvotedUsersLastWeek(res.data))
            .catch(err => console.error("most upvoted users fetch load failed", err));
    }, []);*/

    // handle search requests
    /*
    const handleSearch = () => {
        axios.get(`/user/search?username=${searchQuery}`)
            .then(res => setResults(res.data))
            .catch(err => console.error("Search failed", err));
    };
    */
    // Auto search when user types
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        // Clear previous timer to debounce API calls
        if (typingTimeout) clearTimeout(typingTimeout);

        setTypingTimeout(
        setTimeout(() => {
            if (value.trim()) {
            axios
                .get(`/user/search?username=${value}`)
                .then((res) => setResults(res.data))
                .catch((err) => console.error("Search failed", err));
            } else {
            setResults([]);
            }
        }, 300) // wait 300ms after typing stops
        );
    };

    const getToggleButtonStyles = (active) => ({
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",

        "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)",
        },
    });

    // go to selected profile
    const visitProfile = (userId) => {
        history.push(`/user/view/${userId}`);
    };

    return (
        <div
            style={{
                //padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >
            {/* Top Bar: Buttons in center, search bar at top-right */}
            {/*<div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '30px',
            }}
            >*/}
            {/* Empty space on the left for symmetry */}
            {/*<div style={{ width: '260px' }}></div>*/}
            {/* STICKY HEADER */}
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1200,
        backgroundColor: "#FFFDF8",
        //borderBottom: "1px solid rgba(0,0,0,0.08)",
        px: 3,
        py: 2.2
      }}
    >
      {/*<Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >*/}
     <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            //maxWidth: 1400,
            //mx: "auto", // keeps everything aligned nicely
            width: "100%",
            maxWidth: "100%",
        }}
    >
        {/* Left spacer for symmetry */}
        {/*<Box sx={{ width: 260 }} />*/}
        {/* LEFT — LOGO */}
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 220, // keeps layout stable
            }}
        >
            <Tooltip
                title="Lady Wisdom"
                arrow
                followCursor
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Colloquia Logo"
                    sx={{
                        height: 125,
                        width: "auto",
                        borderRadius: "10px", // rounded edges
                        cursor: "pointer",
                        objectFit: "contain",
                    }}
                />
            </Tooltip>
        </Box>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/mainsocial/following')}
                    >
                        Main Social
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/Government/following')}
                    >
                        Government
                    </Button>
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page3')}
                    >
                        Journalism
                    </Button>*/}
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page4')}
                    >
                        Notifications
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/audiovisual')}
                    >
                        Chat
                    </Button>*/}
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/audiovisual')}
                    >
                        Voting Power
                    </Button>*/}
                    <Button
                        variant="outlined"
                        sx={getToggleButtonStyles(button3Active)}
                        onClick={() => setButton3Active(prev => !prev)}
                    >
                        Voting Power
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/profile')}
                    >
                        Profile
                    </Button>
                </Box>
   
                {/*
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                    sx={{
                        mt: 4,
                        mb: 4,
                    }}
                    >
                    {['Colloquium', 'Government', 'Journalism', 'Literature', 'Audiovisual Media', 'Profile'].map((label, index) => (
                        <Button
                        key={label}
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push(`/page${index + 1}`)}
                        >
                        {label}
                        </Button>
                    ))}
                </Box>
                */}


            {/*
            <Box display="flex" gap={1} alignItems="center">
                <TextField
                placeholder="Search"
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    '& .MuiOutlinedInput-root': {
                    borderRadius: '20px',
                    padding: '0px 8px',
                    },
                    width: '180px', // smaller width
                }}
                />
                <Button variant="contained" size="small" color="primary" onClick={handleSearch}>
                Go
                </Button>
            </Box>
            </div>

            <Box mt={4}>
            <List>
                {results.map((user) => (
                <ListItem key={user._id} button onClick={() => visitProfile(user._id)}>
                    <ListItemText
                    primary={user.username}
                    secondary={`${user.first_name} ${user.last_name}`}
                    />
                </ListItem>
                ))}
            </List>
            </Box>
            */}
            {/* Right Section: Notifications + Chat + Search */}
            <Box
                sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5, // spacing between circle buttons and search bar
                }}
            >
                {/* Notifications Circle Button */}
                <Badge
                    badgeContent={notificationsCount > 0 ? notificationsCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    {/* Notifications Circle Button */}
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                        },
                        }}
                        onClick={() => history.push("/notificationsPage")}
                    >
                        <Box
                            component="img"
                            src={notificationIcon}
                            alt="Notifications"
                            sx={{
                                width: 20,     // control icon size
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none", // prevents weird click behavior
                            }}
                        />
                    </Button>
                </Badge>
                {/* Chat Circle Button */}
                {/*<Button
                    sx={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                    }}
                    onClick={() => history.push("/directmessage")}
                >

                </Button>*/}
                <Badge
                    badgeContent={unreadCount > 0 ? unreadCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => {
                            setUnreadCount(0); // optionally reset when clicked
                            history.push("/directmessage");
                        }}
                    >
                        <Box
                            component="img"
                            src={dmIcon}
                            alt="Messages"
                            sx={{
                                width: 20,
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none",
                            }}
                        />
                    </Button>
                </Badge>

            {/* Search Bar - Top Right */}
            <Box
                sx={{
                    position: 'relative', // parent container for absolute dropdown
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 1,
                }}
            >
                <TextField
                    placeholder="Search"
                    variant="outlined"
                    size="small"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '20px',
                        padding: '0px 8px',
                    },
                    width: '180px',
                    }}
                />

                {/* Search Results - Absolutely positioned */}
                {/*{results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                    {results.map((user) => (
                        <ListItem
                        key={user._id}
                        button
                        onClick={() => visitProfile(user._id)}
                        sx={{
                            padding: '5px 10px',
                            '&:hover': { backgroundColor: '#eee' },
                        }}
                        >
                        <ListItemText
                            primary={user.username}
                            secondary={`${user.first_name} ${user.last_name}`}
                        />
                        </ListItem>
                    ))}
                    </List>
                )}*/}
                {results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                {results.map((user) => (
                    <ListItemButton
                        key={user._id}
                        onClick={() => visitProfile(user._id)}
                        sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 1.5,
                        py: 1,
                        '&:hover': { backgroundColor: '#eee' },
                        }}
                    >
                        {/* Profile Image */}
                        <Avatar
                        src={user.profileImageUrl}
                        alt={user.username}
                        sx={{ width: 36, height: 36 }}
                        />

                        {/* Text stack */}
                        <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                        
                        {/* Full Name (top) */}
                        <Typography
                            sx={{
                            fontSize: "0.9rem",
                            fontWeight: 500,
                            color: "#333",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            {user.first_name} {user.last_name}
                        </Typography>

                        {/* Username (bottom with @) */}
                        <Typography
                            sx={{
                            fontSize: "0.8rem",
                            color: "#666",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            @{user.username}
                        </Typography>

                        </Box>
                    </ListItemButton>
                    ))}
                     </List>
                )}
            </Box>
            </Box>
            </Box>
            </Box>
           {/*} </div>*/}
            {/* profile cards */}
            {/*
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: 1000, // enough width so peeks show
                    height: 300,
                    margin: '0 auto',
                    mt: 4,
                }}
                >
                    */}
                {/* First card */}
                {/*
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        zIndex: topCard === 'first' ? 3 : 1,
                    }}
                >
                    <ProfileCard userInfo={{
                        first_name: 'Alice', last_name: 'Smith',
                        occupation: 'Developer', company: 'Acme', university: 'State U', emails: 'alice@example.com'
                    }} />
                </Box>
                */}
                {/*
                {mostUpvotedUsersLastWeek[0] && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            transition: 'transform 0.3s, z-index 0.3s',
                            zIndex: topCard === 'first' ? 3 : 1,
                        }}
                    >
                        <ProfileCard userInfo={mostUpvotedUsersLastWeek[0]} />
                    </Box>
                )}
                */}
                {/* Second card */}
                {/*
                <Box
                    onMouseEnter={() => setTopCard('second')}
                    onMouseLeave={() => setTopCard('first')}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 40, // peek
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        transform: topCard === 'second' ? 'translateX(-40px)' : 'translateX(0)',
                        // always keep second card above third unless third is hovered
                        zIndex: topCard === 'second' ? 4 : topCard === 'third' ? 2 : 2,
                        cursor: 'pointer',
                    }}
                >
                    <ProfileCard userInfo={{
                        first_name: 'Bob', last_name: 'Jones',
                        occupation: 'Designer', company: 'Beta Corp', university: 'Tech U', emails: 'bob@example.com'
                    }} />
                </Box>
                */}
                {/*
                {mostUpvotedUsersLastWeek[0] && (
                    <Box
                        onMouseEnter={() => setTopCard('second')}
                        onMouseLeave={() => setTopCard('first')}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 40, // peek
                            width: '100%',
                            transition: 'transform 0.3s, z-index 0.3s',
                            transform: topCard === 'second' ? 'translateX(-40px)' : 'translateX(0)',
                            zIndex: topCard === 'second' ? 4 : topCard === 'third' ? 2 : 2,
                            cursor: 'pointer',
                        }}
                    >
                        <PostBoxCard
                            currentUserId={currentUserId}
                            topUserId={topUserId}
                            post={topUserPost}
                        />
                    </Box>
                )}
                */}
                {/* Third card */}
                {/*
                <Box
                    onMouseEnter={() => setTopCard('third')}
                    onMouseLeave={() => setTopCard('first')}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 80, // peek further right
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        transform: topCard === 'third' ? 'translateX(-80px)' : 'translateX(0)',
                        zIndex: topCard === 'third' ? 5 : 1,
                        cursor: 'pointer',
                    }}
                >
                    <ProfileCard userInfo={{
                        first_name: 'Carol', last_name: 'Lee',
                        occupation: 'Manager', company: 'Gamma LLC', university: 'Business School', emails: 'carol@example.com'
                    }} />
                </Box>
                */}
                {/* Third card */}
                {/*
                {mostUpvotedUsersLastWeek[0] && (
                    <Box
                        onMouseEnter={() => setTopCard('third')}
                                onMouseLeave={() => setTopCard('first')}
                                sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 80, // peek further right
                                        width: '100%',
                                        transition: 'transform 0.3s, z-index 0.3s',
                                        transform: topCard === 'third' ? 'translateX(-80px)' : 'translateX(0)',
                                        zIndex: topCard === 'third' ? 5 : 1,
                                        cursor: 'pointer',
                            }}
                    >
                        <FeedCard posts={topUserFeed} />
                    </Box>
                )}
                </Box>
                */}
                {/*
                {topUsers.map((user, index) => (
                    <Box
                    key={user._id}
                    sx={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: 1000,
                        height: 324,
                        margin: '0 auto',
                        mt: index === 0 ? 4 : 8,
                    }}
                    >

                    <Box
                        sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        zIndex: topCard === `first-${index}` ? 3 : 1,
                        }}
                    >
                        <ProfileCard userInfo={user} />
                    </Box>



                    <Box
                        onMouseEnter={() => setTopCard(`second-${index}`)}
                        onMouseLeave={() => setTopCard(`first-${index}`)}
                        sx={{
                        position: 'absolute',
                        top: 0,
                        left: 40, // peek
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        transform: topCard === `second-${index}` ? 'translateX(-40px)' : 'translateX(0)',
                        zIndex: topCard === `second-${index}` ? 4 : topCard === `third-${index}` ? 2 : 2,
                        cursor: 'pointer',
                        }}
                    >
                        <PostBoxCard
                        currentUserId={currentUserId}
                        topUserId={user._id}
                        post={featuredPosts[user._id]}
                        />
                    </Box>



                    <Box
                        onMouseEnter={() => setTopCard(`third-${index}`)}
                        onMouseLeave={() => setTopCard(`first-${index}`)}
                        sx={{
                        position: 'absolute',
                        top: 0,
                        left: 80, // peek further right
                        width: '100%',
                        transition: 'transform 0.3s, z-index 0.3s',
                        transform: topCard === `third-${index}` ? 'translateX(-80px)' : 'translateX(0)',
                        zIndex: topCard === `third-${index}` ? 5 : 1,
                        cursor: 'pointer',
                        }}
                    >
                        <FeedCard posts={feedPosts[user._id] || []} />
                    </Box>
                    </Box>
                ))}
                */}
                {/*
                // WORKING 3 CARDS
                {topUsers.map((user, index) => (
                    <Box
                        key={user._id}
                        sx={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: 1000,
                        height: 324,
                        margin: '0 auto',
                        mt: index === 0 ? 4 : 8,
                        }}
                    >

                        <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            transition: 'transform 0.3s, z-index 0.3s',
                            zIndex:
                            topCard === `first-${index}`
                                ? 3
                                : topCard === `second-${index}` || topCard === `third-${index}`
                                ? 1
                                : 3, // fallback to 3 so it's top by default
                        }}
                        >
                        <ProfileCard userInfo={user} />
                        </Box>


                        <Box
                        onMouseEnter={() => setTopCard(`second-${index}`)}
                        onMouseLeave={() => setTopCard(`first-${index}`)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 40,
                            width: '100%',
                            transition: 'transform 0.3s, z-index 0.3s',
                            transform: topCard === `second-${index}` ? 'translateX(-40px)' : 'translateX(0)',
                            zIndex: topCard === `second-${index}` ? 4 : 2,
                            cursor: 'pointer',
                        }}
                        >
                        <PostBoxCard
                            currentUserId={currentUserId}
                            topUserId={user._id}
                            post={featuredPosts[user._id]}
                        />
                        </Box>


                        <Box
                        onMouseEnter={() => setTopCard(`third-${index}`)}
                        onMouseLeave={() => setTopCard(`first-${index}`)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 80,
                            width: '100%',
                            transition: 'transform 0.3s, z-index 0.3s',
                            transform: topCard === `third-${index}` ? 'translateX(-80px)' : 'translateX(0)',
                            zIndex: topCard === `third-${index}` ? 5 : 1,
                            cursor: 'pointer',
                        }}
                        >
                        <FeedCard posts={feedPosts[user._id] || []} />
                        </Box>
                    </Box>
                    ))}*/}
                    {/*{topUsers.map((user, index) => (
                        <Box
                            key={user._id}
                            sx={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: 1000,
                            height: 324,
                            margin: '0 auto',
                            mt: index === 0 ? 4 : 8,
                            }}
                        >
                          
                            <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                transition: 'transform 0.3s, z-index 0.3s',
                                zIndex:
                                topCard === `first-${index}`
                                    ? 3
                                    : topCard === `second-${index}`
                                    ? 1
                                    : 3, // fallback
                            }}
                            >
                            <ProfileCard userInfo={user} />
                            </Box>

                            
                            <Box
                            onMouseEnter={() => setTopCard(`second-${index}`)}
                            onMouseLeave={() => setTopCard(`first-${index}`)}
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 40,
                                width: '100%',
                                transition: 'transform 0.3s, z-index 0.3s',
                                transform: topCard === `second-${index}` ? 'translateX(-40px)' : 'translateX(0)',
                                zIndex: topCard === `second-${index}` ? 4 : 2,
                                cursor: 'pointer',
                            }}
                            >
                            <PostBoxCard
                                currentUserId={currentUserId}
                                topUserId={user._id}
                                post={featuredPosts[user._id]}
                            />
                            </Box>
                        </Box>
                        ))}*/}
                        {button3Active ? (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      mt: 4,
    }}
  >
    <Box
    sx={{
      maxWidth: 700,   // 👈 controls how wide the text can get
      width: "100%",
      textAlign: "center",
    }}
  >
    {/* Quote */}
    <Typography
      sx={{
        fontFamily: "Georgia, serif",
        letterSpacing: "0.08em",
        mb: 1,
      }}
    >
      The fovndation of every state is the edvcation of its yovth
    </Typography>

    {/* Author */}
    <Typography
      sx={{
        fontFamily: "Georgia, serif",
        letterSpacing: "0.08em",
        mb: 4,
      }}
    >
      — Diogenes
    </Typography>
    <Divider
        sx={{
            width: "40%",
            mx: "auto",
            mb: 4,
            borderColor: "text.primary",
        }}
    />
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
    <Typography sx={{ textAlign: "left", mb: 2 }}>We are on the precipice of America’s greatest shift in the social paradigm. </Typography>
    <Typography sx={{ textAlign: "left", mb: 2 }}>Each bolded integer below represents “voting power” which is based on one's intellectual merits. Voting power is the number of upvotes a user adds to a post when they make a single upvote—this is called “power voting”. In the government page, voting power is used when the user votes. Upvotes and votes are called “power votes”. By the nature of this voting power model, Colloquia is the greatest reflection of the American intelligentsia. Naturally, popular pages maximally surface high-signal posts and posts with a higher probability of being true.</Typography>
    <Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      30,000
    </Box>
  </Typography>
<Typography>Tenured Professor</Typography>
  <Typography>or</Typography>

  <Typography sx={{ mb: 2 }}>
    Highly Distinguished Non-Tenured Professor
  </Typography>

  <Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      25,000
    </Box>
  </Typography>
  <Typography sx={{ mb: 2 }}>Non-Tenured Professor on tenure-track while holding a PhD, JD, or MD</Typography>

<Typography>
<Box component="span" sx={{ fontWeight: 700 }}>
      20,000
    </Box>
  </Typography>
<Typography>PhD student or holder from</Typography>
<Typography sx={{ textAlign: "left" }}>Princeton, MIT, Harvard, Stanford, Yale, CalTech, Duke, Johns Hopkins University, Northwestern, University of Pennsylvania, Cornell, University of Chicago, Brown University, Columbia University, Dartmouth, UCLA, UC Berkeley, Carnegie Mellon University, Rice University, Vanderbilt University, Oxford University, or University of Cambridge.</Typography>
  <Typography>or</Typography>
  <Typography>JD student or holder from</Typography>
<Typography sx={{ textAlign: "left" }}>Yale, Stanford, Harvard, University of Chicago, Columbia University, University of Pennsylvania</Typography>
<Typography>or</Typography>
<Typography sx={{ mb: 2 }}>MD student or holder from any Tier 1 medical school according to US News</Typography>

<Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      12,000
    </Box>
  </Typography>
<Typography>PhD student or holder from</Typography>
 <Typography sx={{ textAlign: "left" }}>Washington University in St. Louis,
Emory University,
University of Notre Dame,
University of Michigan,
Georgetown University,
NYU,
USC,
University of North Carolina--Chapel Hill,
University of Virginia,
Georgia Tech,
Boston College, 
Tufts University, 
Boston University,
University of Miami,
The University of Texas at Austin
</Typography>
  <Typography>or</Typography>
   <Typography>JD student or holder from</Typography>
    <Typography sx={{ textAlign: "left" }}>Duke, Northwestern, UCLA, UC Berkeley, Cornell, Vanderbilt, NYU, Washington University in St. Louis, University of Virginia, Georgetown, University of Michigan, University of Notre Dame, University of Texas--Austin, University of North Carolina--Chapel Hill, Boston College</Typography>
  <Typography>or</Typography>

  <Typography sx={{ mb: 2 }}>
    MD student or holder from any Tier 2 medical school according to US News
  </Typography>

 <Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      10,000
    </Box>
  </Typography>
<Typography>Bachelors or Masters student or holder from</Typography>
  <Typography sx={{ textAlign: "left" }}>Princeton, MIT, Harvard, Stanford, Yale, CalTech, Duke, Johns Hopkins University, Northwestern, University of Pennsylvania, Cornell, University of Chicago, Brown University, Columbia University, Dartmouth, UCLA, UC Berkeley, Carnegie Mellon University, Rice University, Vanderbilt University, Oxford University, or University of Cambridge.</Typography>
  <Typography>or</Typography>
 
  <Typography sx={{ mb: 2 }}>
    Graduated with a &gt;= 3.9 GPA in Math, Physics, or any Engineering from any university
  </Typography>

<Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      5,000
    </Box>
  </Typography>
<Typography>Bachelors or Masters student or holder from</Typography>
<Typography sx={{ textAlign: "left" }}>Washington University in St. Louis,
Emory University,
University of Notre Dame,
University of Michigan,
Georgetown University,
NYU,
USC,
University of North Carolina--Chapel Hill,
University of Virginia,
Georgia Tech,
Boston College, 
Tufts University, 
Boston University,
University of Miami,
The University of Texas at Austin
</Typography>
<Typography>or</Typography>
  <Typography sx={{ mb: 2 }}>
    Graduated with a &gt;= 3.5 GPA in Math, Physics, or any Engineering from any university
  </Typography>

<Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      500
    </Box>
  </Typography>
<Typography>Bachelors or Masters student or holder from</Typography>
  <Typography sx={{ mb: 2, textAlign: "left" }}>
    UCSD, UC Davis, UC Santa Barbara, UC Irvine, University of Washington, Cal Poly San Luis Obispo, University of Florida, University of Illinois Urbana-Champaign, Harvey Mudd College, Case Western Reserve University, William & Mary, Northeastern University, University of Maryland, College Park, The Ohio State University, Wake Forest University, Rensselaer Polytechnic Institute, Virginia Tech, Purdue University, University of Wisconsin--Madison, Texas A&M University, Pepperdine University, Pomona College
  </Typography>

<Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      10
    </Box>
  </Typography>
  <Typography sx={{ mb: 2 }}>.edu email from unlisted university</Typography>

  <Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      1
    </Box>
  </Typography>
  <Typography sx={{ mb: 2 }}>.gmail email/phone number</Typography>

<Typography>
    <Box component="span" sx={{ fontWeight: 700 }}>
      +1000 Booster
    </Box>
  </Typography>
  <Typography sx={{ mb: 2 }}>Math, physics, or computer science U.S. national olympiad medalist</Typography>

  </Box>
    <Typography
      sx={{
    maxWidth: 700,
    color: "#333333",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    fontSize: "1.1rem",
    lineHeight: 1.6,
    textAlign: "left", 
    mb: 10 
  }}
    >
      If you’re eligible for more voting power, please email votingpower.colloquia.us@gmail.com using the same school email as your account with proof along with your username so that we can manually update your voting power. The email is being maintained by members of executive staff at Colloquia for accurate voting power apportionment.
    </Typography>
    </Box>
  </Box>
) : (
  <>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 2,
                            mb: 2,
                            gap: 0.5,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#333333",            // same as buttons
                                fontFamily: "Roboto, sans-serif", // matches MUI buttons
                                fontWeight: 500,             // matches button font weight
                                fontSize: "2rem",            // similar visual size to buttons
                                letterSpacing: "0.02857em",  // MUI button default spacing
                                textTransform: "none",       // buttons are not uppercase in your case
                            }}
                        >
                            INFLUENCERS OF THE WEEK
                        </Typography>
                        <Typography
                            sx={{
                                color: "#333333",            // same as buttons
                                fontFamily: "Roboto, sans-serif", // matches MUI buttons
                                fontWeight: 500,             // matches button font weight
                                fontSize: "1.1rem",            // similar visual size to buttons
                                letterSpacing: "0.02857em",  // MUI button default spacing
                                textTransform: "none",       // buttons are not uppercase in your case
                            }}
                        >
                            Intellectuals with the most power votes last week
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center", // centers cards horizontally
                            width: "100%",
                        }}
                    >
                        {topUsers.map((user, index) => (
                            <Box
                                key={user._id}
                                sx={{
                                    width: '100%',
                                    maxWidth: 1000, // controls card width
                                    mt: index === 0 ? 2 : 4,
                                    display: "flex",
                                    justifyContent: "center", // censures centering
                                }}
                            >
                                <ProfileCard userInfo={user} />
                            </Box>
                        ))}
                    </Box>
                </>
                )}

        </div>
    );


    /*
    // component returns jsx to render ui
    return (
        // div: group together other elements on a webpage
        // outer container div with padding
        <div style={{ padding: '20px' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',           // optional: allows wrapping if screen too small
                    width: '100%',              // ensures it spans full width
                    maxWidth: '1000px',         // optional max width
                    margin: '0 auto',           // center the button group
                    gap: '10px',
                }}
            >
                <button onClick={() => history.push('/page1')}>Colloquium</button>
                <button onClick={() => history.push('/page2')}>Government</button>
                <button onClick={() => history.push('/page3')}>Journalism</button>
                <button onClick={() => history.push('/page4')}>Literature</button>
                <button onClick={() => history.push('/page5')}>Audiovisual Media</button>
                <button onClick={() => history.push('/profile')}>Profile</button>
            </div>

            <Box mt={4}>
                <Typography variant="h6">Search for a Username</Typography>
                <Box display="flex" gap={2} mt={2}>
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                <Button variant="contained" color="primary" onClick={handleSearch}>
                    Search
                </Button>
                </Box>

                <List>
                    {results.map(user => (
                        <ListItem key={user._id} button onClick={() => visitProfile(user._id)}>
                            <ListItemText
                                primary={user.username}
                                secondary={`${user.first_name} ${user.last_name}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </div>
    );
    */
}

export default HomePage;
/*
import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import {
  TextField, Button, Box, Typography, List, ListItem, ListItemText, Divider, Container
} from '@mui/material';

function HomePage() {
    const [open, setOpen] = useState(false);

    // state initialize to an empty array to store a list of posts
    // 'posts': stores an array of post objects fetched from server
    // 'setPosts': updates posts state
    const [posts, setPosts] = useState([]);

    // store username
    const [username, setUsername] = useState(""); 

    // store user info
    const [userInfo, setUserInfo] = useState(null);

    // tier classification based on user's academic and industry practitioner accolades
    // used for voting power where each tier is assigned an integer which is their voting power
    const [userTier, setUserTier] = useState("");

    // switch between view and edit states
    const [isEditing, setIsEditing] = useState(false);

    // profile info that user can edit
    const [editInfo, setEditInfo] = useState({ username: "", first_name: "", last_name: "", occupation: "", company: "", university: "", blurb: "", });

    // fetch user info
    useEffect(() => {
        axios.get('/user/me')
            .then(res => {
                setUserInfo(res.data);
                setUserTier(res.data.tier || "");  // Load saved tier
            })
            .catch(err => console.error("Failed to fetch user info", err)); 
        }, []);

    // fetch user info
    useEffect(() => {
        axios.get('/user/info')
        .then(res => setUsername(res.data.username))
        .catch(err => console.error("Failed to load user info", err));
    }, []);

    // fetch user's posts once component loads 
    useEffect(() => {
            axios.get('/user/posts') // send GET request to /user/posts
                .then(response => setPosts(response.data)) // update posts with user's post data from response
                .catch(err => console.error("Failed to fetch posts", err));
    }, []);

    // refresh posts after submitting a new one
    const refreshPosts = () => {
            axios.get('/user/posts') // send GET request to /user/posts
                .then(response => setPosts(response.data)) // update posts with user's post data from response
                .catch(err => console.error("Failed to refresh posts", err));
    };

    // fill editInfo when userInfo loads
    useEffect(() => {
        if (userInfo) {
            setEditInfo({
                username: userInfo.username || "",
                first_name: userInfo.first_name || "",
                last_name: userInfo.last_name || "",
                occupation: userInfo.occupation || "",
                company: userInfo.company || "",
                university: userInfo.university || "",
                blurb: userInfo.blurb || "",
            });
        }
    }, [userInfo]);

    // react handler that updates editInfo state as user types
    // declare a fxn that recieves the event change e from any input element
    const handleChange = e => {
        // update editInfo state with previous state object
        setEditInfo((prev) => ({
            // copy everything that is already in editInfo
            ...prev, 
            // overwrite single field input that changed
            [e.target.name]: e.target.value,
        }));
    };

   const saveChanges = async () => {
        try {
            const response = await axios.put("/user/updateTier", editInfo);

            // The updated user data comes from the server, including the new tier
            const updatedUser = response.data;

            // Update both userInfo and userTier directly
            setUserInfo(updatedUser);
            setUserTier(updatedUser.tier || "Unclassified");

            setIsEditing(false);
        } catch (err) {
            console.error("Update failed:", err);
        }
    };
    //___________________________________________________________________________________
    const history = useHistory();
    const [searchQuery, setSearchQuery] = useState("");
    const [results, setResults] = useState([]);
    const homeSectionRef = useRef(null);  // Reference to home-section div

    const handleSearch = () => {
        axios.get(`/user/search?username=${searchQuery}`)
            .then(res => setResults(res.data))
            .catch(err => console.error("Search failed", err));
    };

    const visitProfile = (userId) => {
        history.push(`/user/view/${userId}`);
    };

    // On mount, scroll to Home section
    useEffect(() => {
        if (homeSectionRef.current) {
            homeSectionRef.current.scrollIntoView({ behavior: "auto" });
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
            top: document.getElementById("home-section").offsetTop,
            behavior: "smooth"
            });
        }, 0);
    }, []);

    return (
        <div style={{ height: "200vh", overflowY: "scroll" }}>
            <div id="profile-section" style={{ minHeight: "100vh" }}>
                <Typography variant="h4">Profile</Typography>
            </div>

            <div
                ref={homeSectionRef}
                id="home-section"
                style={{ minHeight: "100vh", background: "#f5f5f5", padding: "20px" }}
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                    sx={{
                        mt: 4,
                        mb: 4,
                    }}
                    >
                    <Button
                        variant="contained"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/page1')}
                    >
                        Colloquium
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/page2')}
                    >
                        Government
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/page3')}
                    >
                        Journalism
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/page4')}
                    >
                        Literature
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/page5')}
                    >
                        Audiovisual Media
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ padding: "6px 12px" }}
                        onClick={() => history.push('/profile')}
                    >
                        Profile
                    </Button>
                </Box>


                <Box mt={4}>
                    <Typography variant="h6">Search for a Username</Typography>
                    <Box display="flex" gap={2} mt={2}>
                        <TextField
                            label="Username"
                            variant="outlined"
                            fullWidth
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <Button variant="contained" color="primary" onClick={handleSearch}>
                            Search
                        </Button>
                    </Box>

                    <List>
                        {results.map(user => (
                            <ListItem
                                key={user._id}
                                button
                                onClick={() => visitProfile(user._id)}
                            >
                                <ListItemText
                                    primary={user.username}
                                    secondary={`${user.first_name} ${user.last_name}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </div>
        </div>
    );
}

export default HomePage;
*/
/*
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  TextField, Button, Box, Typography, List, ListItem, ListItemText
} from '@mui/material';

// display five buttons on top after login

// define a functional react component called home page
function HomePage() {
    const history = useHistory();

    // state for search input
    const [searchQuery, setSearchQuery] = useState("");

    // state for search results
    const [results, setResults] = useState([]);

    // handle search requests
    const handleSearch = () => {
        axios.get(`/user/search?username=${searchQuery}`)
            .then(res => setResults(res.data))
            .catch(err => console.error("Search failed", err));
    };

    // go to selected profile
    const visitProfile = (userId) => {
        history.push(`/user/view/${userId}`);
    };

    // component returns jsx to render ui
    return (
        // div: group together other elements on a webpage
        // outer container div with padding
        <div style={{ padding: '20px' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',           // optional: allows wrapping if screen too small
                    width: '100%',              // ensures it spans full width
                    maxWidth: '1000px',         // optional max width
                    margin: '0 auto',           // center the button group
                    gap: '10px',
                }}
            >
                <button onClick={() => history.push('/page1')}>Colloquium</button>
                <button onClick={() => history.push('/page2')}>Government</button>
                <button onClick={() => history.push('/page3')}>Journalism</button>
                <button onClick={() => history.push('/page4')}>Literature</button>
                <button onClick={() => history.push('/page5')}>Audiovisual Media</button>
                <button onClick={() => history.push('/profile')}>Profile</button>
            </div>

            <Box mt={4}>
                <Typography variant="h6">Search for a Username</Typography>
                <Box display="flex" gap={2} mt={2}>
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                <Button variant="contained" color="primary" onClick={handleSearch}>
                    Search
                </Button>
                </Box>

                <List>
                    {results.map(user => (
                        <ListItem key={user._id} button onClick={() => visitProfile(user._id)}>
                            <ListItemText
                                primary={user.username}
                                secondary={`${user.first_name} ${user.last_name}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </div>
    );
}

export default HomePage;
*/
